import { render, staticRenderFns } from "./PurchaseAuthLetterDialog.vue?vue&type=template&id=6c71d3e5&scoped=true"
import script from "./PurchaseAuthLetterDialog.vue?vue&type=script&lang=js"
export * from "./PurchaseAuthLetterDialog.vue?vue&type=script&lang=js"
import style0 from "./PurchaseAuthLetterDialog.vue?vue&type=style&index=0&id=6c71d3e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c71d3e5",
  null
  
)

export default component.exports